export default __webpack_public_path__ + "static/media/gloves_of_the_doomsayer.6cff472f.jpg";